export enum PurchasingTypes {
	Requisition = 1,
	PurchaseOrder = 2,
}
